import { unityPlayerMethods, unity } from "../unity/unity-methods";
import {UnityPlayerAPILoaderConfig, UnityPlayerAPIMessageInterface} from "./interfaces";

// @ts-ignore
const getUnityPlayerInstatiationFunction = () => window.createUnityInstance;

const unityPlayerApi = {
    isPlayerInstantiationFunctionAvailable: getUnityPlayerInstatiationFunction,
    createUnityInstance: (canvas: HTMLElement, loaderConfig: UnityPlayerAPILoaderConfig, onProgress?: Function) => {
            return unity.createUnityInstance(canvas, loaderConfig, onProgress);
    },
    quitUnityPlayerInstance: (playerInstance: any, onQuitCallback: Function) => unityPlayerMethods.quitPlayer(playerInstance, onQuitCallback),
    sendMessage: (playerInstance: any, message: UnityPlayerAPIMessageInterface) => { unityPlayerMethods.sendMessage(playerInstance, message)}
}

export default unityPlayerApi;
